import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const CheckIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.500"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMin meet"
  >
    <Path
      d="M9.45493 17.5C9.31675 17.5 9.18721 17.4793 9.0663 17.438C8.94539 17.3973 8.83311 17.3277 8.72948 17.2293L4.27309 12.9966C4.08308 12.8162 3.99223 12.5822 4.00052 12.2948C4.0095 12.008 4.10899 11.7744 4.29899 11.594C4.489 11.4135 4.73082 11.3233 5.02445 11.3233C5.31809 11.3233 5.55991 11.4135 5.74991 11.594L9.45493 15.113L18.2382 6.77069C18.4282 6.59023 18.6745 6.5 18.9771 6.5C19.279 6.5 19.525 6.59023 19.715 6.77069C19.905 6.95116 20 7.18477 20 7.47154C20 7.75897 19.905 7.99292 19.715 8.17338L10.1804 17.2293C10.0768 17.3277 9.96448 17.3973 9.84357 17.438C9.72266 17.4793 9.59312 17.5 9.45493 17.5Z"
      fill={color}
    />
  </Svg>
);

export default CheckIcon;
